// DO NOT EDIT THIS IS AN AUTOGENERATED FILE;
import * as React from 'react'

interface IconProps {
  color?: string
  size?: string | number
}

const SvgLocation = ({color = 'currentColor', size = 20}: IconProps) => (
  <svg
    viewBox="0 0 20 20"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    height={size}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.773 2.212a.75.75 0 0 1 .161.845l-6.5 14.5a.75.75 0 0 1-1.348.041l-2.627-5.014-5.004-2.145a.75.75 0 0 1-.031-1.364l14.5-7a.75.75 0 0 1 .849.137ZM4.559 9.71l3.736 1.602a.75.75 0 0 1 .37.341l2.033 3.882 5.027-11.215L4.559 9.71Z"
    />
  </svg>
)

export default SvgLocation
